import { render, staticRenderFns } from "./NovaPopover.vue?vue&type=template&id=53298a5e&lang=pug&"
import script from "./NovaPopover.vue?vue&type=script&lang=js&"
export * from "./NovaPopover.vue?vue&type=script&lang=js&"
import style0 from "./NovaPopover.vue?vue&type=style&index=0&id=53298a5e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports